export default __webpack_public_path__ + "static/media/furniture9.2dfc2741.jpeg";